import {Component, computed, contentChild, input, output, signal, TemplateRef} from '@angular/core';
import {Dialog} from 'primeng/dialog';
import {ElciaButton} from '../buttons/button/button';
import {TranslatePipe} from '@ngx-translate/core';
import {NgTemplateOutlet} from '@angular/common';
import {IconType} from '../icon/icon';

@Component({
  selector: 'elcia-dialog',
  imports: [
    Dialog,
    ElciaButton,
    TranslatePipe,
    NgTemplateOutlet
  ],
  templateUrl: './dialog.html',
  styleUrl: './dialog.scss',
})
export class ElciaDialog {
  size = input.required<DialogSize>();
  title = input<string>();

  mustDisplayDeleteButton = input(false);
  mustDisplayActionButton = input(true);
  mustDisplayCancelButton = input(true);
  isActionLoading = input(false);
  actionLabel = input<string>('action.save');
  actionIcon = input<IconType>('save');

  headerTemplate = contentChild<TemplateRef<any>>('dialogHeader');

  onClose = output();
  onDelete = output();
  onAction = output();
  remBySize = computed(() => {
    switch (this.size()) {
      case 'x-small':
        return 30;
      case 'small' :
        return 50;
      case 'medium' :
        return 70;
      case 'large':
        return 100;
      case 'x-large':
        return 120;
      default :
        return undefined; // Default size by prime
    }
  })


  protected visible = signal(true);

  protected close() {
    this.visible.set(false);
    this.onClose.emit();
  }

  protected action() {
    this.onAction.emit();
  }

  protected delete() {
    this.onDelete.emit();
  }
}

export type DialogSize = 'x-small' | 'small' | 'medium' | 'large' | 'x-large';
